(() => {
  const params = new URLSearchParams(location.search);
  const product = params.get('product');
  if (!product) return;
  const field = document.querySelector('[name="contact[Product / SKU]"]');
  if (field && !field.value) field.value = [product, params.get('variant'), params.get('sku')].filter(Boolean).join(' — ');
  const linkField = document.querySelector('[data-nyi-product-link]');
  const link = params.get('product_url');
  if (linkField && link) {
    try {
      const url = new URL(link);
      if (url.origin === location.origin && url.pathname.startsWith('/products/')) linkField.value = url.href;
    } catch (_) { /* An incomplete enquiry URL must not break the contact form. */ }
  }
})();
